(function () {
  "use strict";

  if (window.n9VariantMediaScrollInitialized) {
    return;
  }
  window.n9VariantMediaScrollInitialized = true;

  var VISIBLE_RATIO = 0.55;
  var pendingTimer = 0;

  function prefersReducedMotion() {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function headerOffset() {
    var styles = window.getComputedStyle(document.documentElement);
    var sticky = parseFloat(styles.getPropertyValue("--sticky_offset")) || 0;
    var pad = parseFloat(styles.getPropertyValue("--rpp")) || 16;
    return sticky + pad;
  }

  function productRoot() {
    return document.querySelector("#main-product.m6pr");
  }

  function isVariantControl(el) {
    if (!el || el.nodeType !== 1) {
      return false;
    }

    return el.matches(
      'input[type="radio"][name^="options"], input[type="radio"][name="variant-id"], select[name^="options"], select[name="variant-id"]'
    );
  }

  function isQuickshopOpen() {
    var quickshop = document.getElementById("quickshop");
    return !!(quickshop && quickshop.classList.contains("toggle"));
  }

  function galleryTarget(product) {
    var gallery = product.querySelector(".l4pr");
    if (!gallery) {
      return product.querySelector(".l4pr-container");
    }

    if (gallery.classList.contains("static")) {
      var position = gallery.getAttribute("data-featured_media_position");
      if (position && position !== "0") {
        var anchor = product.querySelector("#section-product-" + position);
        if (anchor) {
          return anchor.closest("li") || anchor;
        }
      }
    }

    return (
      product.querySelector(".l4pr .swiper-outer") ||
      product.querySelector(".l4pr-container") ||
      gallery
    );
  }

  function isMostlyVisible(el) {
    var rect = el.getBoundingClientRect();
    var topBound = headerOffset();
    var visibleTop = Math.max(rect.top, topBound);
    var visibleBottom = Math.min(rect.bottom, window.innerHeight);
    var visibleHeight = Math.max(0, visibleBottom - visibleTop);
    var needed = Math.min(rect.height, window.innerHeight - topBound) * VISIBLE_RATIO;
    return visibleHeight >= needed;
  }

  function scrollToEl(el) {
    var offset = headerOffset();
    var scroller = document.scrollingElement || document.documentElement;
    var top = el.getBoundingClientRect().top + scroller.scrollTop - offset;
    var behavior = prefersReducedMotion() ? "auto" : "smooth";

    if (typeof el.scrollIntoView === "function") {
      el.scrollIntoView({
        behavior: behavior,
        block: "start"
      });
    }

    if (Math.abs(el.getBoundingClientRect().top - offset) <= 48) {
      return;
    }

    if (typeof scroller.scrollTo === "function") {
      scroller.scrollTo({
        top: Math.max(0, top),
        behavior: behavior
      });
    }

    if (Math.abs(el.getBoundingClientRect().top - offset) <= 48) {
      return;
    }

    scroller.scrollTop = Math.max(0, top);
  }

  function scrollToSelectedMedia() {
    if (isQuickshopOpen() || document.documentElement.classList.contains("n9-package-guide-open")) {
      return;
    }

    var product = productRoot();
    if (!product || product.hasAttribute("data-n9-disable-variant-media-scroll")) {
      return;
    }

    var target = galleryTarget(product);
    if (!target || isMostlyVisible(target)) {
      return;
    }

    scrollToEl(target);
  }

  function scheduleScroll() {
    scrollToSelectedMedia();
    window.clearTimeout(pendingTimer);
    pendingTimer = window.setTimeout(scrollToSelectedMedia, 80);
  }

  document.addEventListener(
    "change",
    function (event) {
      var el = event.target;
      if (!isVariantControl(el) || !el.closest("#main-product.m6pr")) {
        return;
      }
      scheduleScroll();
    },
    true
  );

  window.addEventListener("themeVariantUpdated", function () {
    window.clearTimeout(pendingTimer);
    pendingTimer = window.setTimeout(scrollToSelectedMedia, 80);
  });
})();
